import { MenuOutlined } from '@ant-design/icons';
import React from 'react';

import 'styles/layout/Sortable/sortable-handle.scss';

export const SortableHandleComponent = React.forwardRef((props, ref) => (
  <MenuOutlined ref={ref} className="sortable-handle" {...props} />
));

SortableHandleComponent.displayName = 'SortableHandleComponent';
